import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailSummaryTMS.js';
import { Button } from '@synergycms_core/components/generic';
import { List, Map, isImmutable } from 'immutable';
import connect from 'react-redux/es/connect/connect';
import moment from 'moment';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import AvailMainSideSummaryTMS from '../AvailMainSideSummary/AvailMainSideSummaryTMS.jsx';
import { getRoomName } from '../../../utils';

const AvailSummaryTMS = class AvailSummaryTMS extends React.Component {
    static displayName = 'AvailSummaryTMS';

    render() {
        const { config, theme } = this.props,
            {
                hotel,
                reservationObj,
                isTMSRequest
            } = config;

        let totalPriceRooms = 0;
        let totalPriceServices = 0;
        const occupancies = {
            10: 0, // Adult
            8: 0 // Child
        };
        const breakdown = [];
        let langCode = reservationObj && (reservationObj.getIn(['customer', 'lang'], false) || reservationObj.getIn(['language'], false) || 'en');
        const { classes } = theme.styles;
        const showTaxes = hotel.get('show_taxes');
        if(!isTMSRequest) {
            reservationObj.get('blocks').forEach(block => {
                const roomId = block.get('room_id').toString();
                const occupGroupId = block.get('occup_group_id');
                const boardId = block.get('board_id').toString();
                const reservationRequestBlock = reservationObj.getIn(['blocks', block.get('idx') - 1]);

                const occupGroup = reservationObj.get('occup_groups').find(og => {
                    return +og.get('id') === +occupGroupId;
                });

                let adults = 0;
                let childs = 0;
                const babies= null; //block.get('babies');
                const childsInfo= null; //block.get('childs_info');

                occupGroup.get('occupancies').forEach(occupancy => {
                    occupancies[occupancy.get('code')] += occupancy.get('count');
                    if (occupancy.get('code') === '10') {
                        adults = occupancy.get('count');
                    } else {
                        childs = occupancy.get('count');
                    }

                });

                const room = reservationObj.get('rooms').find(r => +r.get('id') === +block.get('room_id'));

                const sections = reservationObj.get('sections', List());

                const roomInfo = (isImmutable(sections) && sections.find(s => s && +s.get('content_type_id') === +roomId && s.get('content_type_occup_group_id') === occupGroupId)) ||
                  sections.find(s => s && +s.get('content_type_id') === +roomId && s.get('content_type_occup_group_id') === room.get('default_occup_group_id'));

                const roomTranslations = roomInfo && roomInfo.getIn(['translations', langCode]);

                const needAddOccupName = (roomInfo && roomInfo.get('occup_group_id') !== reservationRequestBlock.get('occup_group_id')) || childsInfo;

                let roomOccupName =  getRoomName({ childs, adults, babies, childsInfo });

                let roomTitle;

                if (roomTranslations && !childsInfo) {
                    roomTitle = roomTranslations.get('title') ? roomTranslations.get('title') : roomTranslations.get('default_title', 'room');
                } else {
                    roomTitle = reservationObj
                      .get('rooms')
                      .find(s => +s.get('id') === +roomId)
                      .getIn(['translations', langCode, 'name'], 'room');
                }

                if (needAddOccupName) {
                    roomTitle += roomOccupName;
                }

                const board = reservationObj
                  .get('boards')
                  .find(b => +b.get('id') === +boardId)
                  .getIn(['translations', langCode]);


                let boardName = 'board';
                if (board && board.get) {
                    const corporate = block.get('is_corporate', false);
                    boardName = corporate && board.get('corporate_name') ? board.get('corporate_name') : board.get('custom_name_web') ? board.get('custom_name_web') : board.get('name', 'board');
                }

                let roomPrice = showTaxes ? block.get('price_tax') : block.get('price');
                totalPriceRooms = totalPriceRooms + roomPrice;
                totalPriceServices = totalPriceServices + 0;

                breakdown.push({
                    room: roomTitle,
                    board: boardName,
                    price: roomPrice,
                });
            });
            totalPriceRooms = reservationObj && parseFloat(reservationObj.get(showTaxes ? 'total_price_tax' : 'total_price', 0));
        } else {
            totalPriceRooms = reservationObj && parseFloat(reservationObj.get('room_amount', 0));
            totalPriceServices = reservationObj && parseFloat(reservationObj.get('extra_amount', 0));
        }

        return (
            <div className={classes.resumeFullContainer}>
                <div className={classes.resumeFull}>
                    <div className={classes.resume}>
                        <div className={classes.summary}>
                            <AvailMainSideSummaryTMS fullVersion={false} innerStyle={'confirmationSummary'} />
                        </div>
                    </div>
                    <div className={classes.actionsContainer}>
                        <div className={classes.actions}>
                            <ul className={classes.actionsGrid}>
                                <li className={classes.actionContainer}>
                                    <Button
                                        onClick={() => window.print()}
                                        innerStyle={classes.actionIconContainer}
                                        icon={{
                                            unicodeContent: 'e15d',
                                            innerStyle: [classes.actionIcon]
                                        }}
                                        ariaLabel={'_%print%_'}
                                        translate={true}
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapDispatchToProps = dispatch => {
    return {};
};

const mapStateToProps = (store, ownProps) => {

    const hotelId = store.getIn(['customer', 'current_hotel']);
    const hotelInfo = store.getIn(['hotels', hotelId]);
    const reservationObj = store.getIn(['customer', 'reservation'], false) || store.getIn(['customer', 'reservation'], false);
    const isTMSRequest = store.getIn(['customer', 'params', 'url_params', 'from_tms'], false) === 'true' && reservationObj.get('status_id',false);

    const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;

    let adults = 0,
      childs = 0;

    const occupGroups = [];

    if(!isTMSRequest) {
        const reservationBlocks = reservationObj && reservationObj.get('blocks');

        reservationBlocks.forEach(block => {
            occupGroups.push(block.get('occup_group_id',false));
        });
        const reservationOccups = reservationObj && reservationObj.get('occup_groups');
        occupGroups.forEach(occupGroup => {
            let occup = reservationOccups.find(d => (d.get('id', '') || '') === occupGroup || false);
            let occupancies = occup && occup.get('occupancies');
            occupancies.forEach((occ) => {
                if(occ.get('code') === '10') {
                    adults += occ.get('count',0);
                } else {
                    childs += occ.get('count',0);
                }
            });
        });
    } else {
        adults = reservationObj && reservationObj.get('adults', 0);
        childs = reservationObj && reservationObj.get('childs', 0);
    }

    return {
        reservationObj: reservationObj.size ? reservationObj : undefined,
        hotel: hotel,
        totalAdults: adults,
        totalChilds: childs,
        checkin: reservationObj && reservationObj.get('checkin', 0),
        checkout: reservationObj && reservationObj.get('checkout', 0),
        nights: Math.abs(moment(reservationObj && reservationObj.get('checkin', 0))
            .diff(reservationObj && reservationObj.get('checkout', 0), 'days')),
        isTMSRequest: isTMSRequest
    };
};

export default compose(
    validateAsyncComponent(mapStateToProps, []),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    PropertyManager([
        'reservationObj',
        'hotel',
        'totalAdults',
        'totalChilds',
        'checkin',
        'checkout',
        'nights',
        'reservationTMS',
        'isTMSRequest'
      ]),
    withThemeJSS({ styleFile, link: true }),
    withContent('i18n')
)(AvailSummaryTMS);
